import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=f183b378"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports